module.exports = __webpack_public_path__ + "static/media/musicalInstrument.d3515dcc.svg";